import { render } from "./TvmPreLoader.vue?vue&type=template&id=73c4892c&scoped=true"
import script from "./TvmPreLoader.vue?vue&type=script&lang=js"
export * from "./TvmPreLoader.vue?vue&type=script&lang=js"

import "./TvmPreLoader.vue?vue&type=style&index=0&id=73c4892c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c4892c"],['__file',"src/components/ChatWidget/TvmPreLoader/TvmPreLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73c4892c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73c4892c', __exports__)) {
    api.reload('73c4892c', __exports__)
  }
  
  module.hot.accept("./TvmPreLoader.vue?vue&type=template&id=73c4892c&scoped=true", () => {
    api.rerender('73c4892c', render)
  })

}


export default __exports__